// cafe/client/src/utils/notificationUtils.js
import { formatDistanceToNow } from 'date-fns';
import { es, enUS } from 'date-fns/locale';
import i18n from '../i18n';

const locales = { es, en: enUS };

export const getNotificationDetails = (notification) => {
  const { sender, type, entityId, entityType, entityCreatorUsername } =
    notification;

  let tKey = '';
  let link = '/';
  const senderUsername = sender?.username || 'Alguien';

  switch (type) {
    case 'NEW_POST':
      tKey = 'notifications.new_post';
      link = `/u/${senderUsername}/posts/${entityId}`;
      break;
    case 'NEW_PACK':
      tKey = 'notifications.new_pack';
      link = `/u/${senderUsername}/packs/${entityId}`;
      break;
    case 'NEW_FOLLOWER':
      tKey = 'notifications.new_follower';
      link = `/u/${senderUsername}`;
      break;
    case 'NEW_COMMENT':
      tKey = 'notifications.new_comment';
      link = `/u/${entityCreatorUsername}/${entityType}s/${entityId}`;
      break;
    case 'NEW_REPLY':
      tKey = 'notifications.new_reply';
      link = `/u/${entityCreatorUsername}/${entityType}s/${entityId}`;
      break;
    // --- INICIO DE LA NUEVA LÓGICA ---
    case 'NEW_DONATION':
      tKey = 'notifications.new_donation';
      // Al hacer clic, el creador irá a su panel de donaciones recibidas.
      link = '/dashboard/donations';
      break;
    // --- FIN DE LA NUEVA LÓGICA ---
    default:
      tKey = 'notifications.default';
      link = `/u/${senderUsername}`;
  }

  const tParams = { sender: senderUsername };

  return { tKey, tParams, link };
};

export const formatTimeAgo = (dateString) => {
  if (!dateString) return '';
  return formatDistanceToNow(new Date(dateString), {
    addSuffix: true,
    locale: locales[i18n.language] || es,
  });
};
